import { AHSeparator, Box, Dialog, ListItem } from "arkh";
import { graphql, useFragment, useMutation } from "react-relay";
import { SelectSecondaryScheduleTypeDimension_integrationTilTid$key } from "./__generated__/SelectSecondaryScheduleTypeDimension_integrationTilTid.graphql";
import { FlatList } from "react-native";
import { useState } from "react";
import { OrgButton } from "../OrgHome/OrgButton";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { useAlert } from "../../common/Alert";
import { FormattedMessage } from "react-intl";

export function SelectSecondaryScheduleTypeDimension(props: {
  integrationTilTid: SelectSecondaryScheduleTypeDimension_integrationTilTid$key;
  visible: boolean;
  onClose: () => void;
}) {
  const intl_tokens = useIntlTokens();
  const integrationTilTid = useFragment(
    graphql`
      fragment SelectSecondaryScheduleTypeDimension_integrationTilTid on IntegrationTilTid {
        id
        secondaryScheduleTypeOptions {
          id
          name
          providerId
        }
        secondaryScheduleTypeOption {
          id
          name
          providerId
        }
      }
    `,
    props.integrationTilTid
  );
  const [
    selectedSecondaryScheduleTypeDimensionId,
    setSelectedSecondaryScheduleTypeDimensionId,
  ] = useState(
    integrationTilTid.secondaryScheduleTypeOption?.providerId ?? null
  );

  const [updateIntegrationTilTid, updateIntegrationTilTidLoading] = useMutation(
    graphql`
      mutation SelectSecondaryScheduleTypeDimensionMutation(
        $input: IntegrationTilTidUpdateInput!
      ) {
        store {
          updateIntegrationTilTid(input: $input) {
            id
            secondaryScheduleTypeOption {
              id
              name
            }
          }
        }
      }
    `
  );

  const Alert = useAlert();
  const setSecondaryScheduleTypeDimension = (
    secondaryScheduleTypeDimensionId: string | null
  ) => {
    updateIntegrationTilTid({
      variables: {
        input: { secondaryScheduleTypeDimensionId },
      },
      onCompleted: () => {
        props.onClose();
      },
      onError: (error) => {
        Alert.error("Error");
      },
    });
  };

  const listData = integrationTilTid.secondaryScheduleTypeOptions ?? [];
  return (
    <Dialog
      visible={props.visible}
      onClose={props.onClose}
      title={
        <FormattedMessage
          description="SelectSecondaryScheduleTypeDimension Title"
          defaultMessage="Select sub-schedule"
        />
      }
    >
      <FlatList
        data={listData}
        ItemSeparatorComponent={AHSeparator}
        keyExtractor={(item) => item.providerId}
        renderItem={({ item }) => {
          return (
            <ListItem
              right={
                <ListItem.SingleSelectIndicator
                  selected={
                    selectedSecondaryScheduleTypeDimensionId === item.providerId
                  }
                />
              }
              onPress={() => {
                if (
                  selectedSecondaryScheduleTypeDimensionId === item.providerId
                ) {
                  setSelectedSecondaryScheduleTypeDimensionId(null);
                } else {
                  setSelectedSecondaryScheduleTypeDimensionId(item.providerId);
                }
              }}
            >
              <ListItem.Title>{item.name}</ListItem.Title>
            </ListItem>
          );
        }}
      />
      <Box space="medium" shadow="strong" color="surface-primary">
        <OrgButton
          style={{ alignSelf: "stretch" }}
          title={intl_tokens.Save}
          backgroundColor="primary"
          tintColor="text-inverted"
          onPress={() => {
            setSecondaryScheduleTypeDimension(
              selectedSecondaryScheduleTypeDimensionId
            );
          }}
          loading={updateIntegrationTilTidLoading}
        />
      </Box>
    </Dialog>
  );
}
